module.exports = __webpack_public_path__ + "svg/cancel_red.aa4a5a83d7a413308b3d39e08a7a7b2f.svg";